
import axios from 'axios';
// eslint-disable-next-line import/no-unresolved, import/no-extraneous-dependencies, import/extensions
import config from 'config';

const qs = require('qs');

const state = {
	contact: {},
	dialog: {},
	ticketTypes: null,
	greeting: {
		on_facebook: '',
		on_website: '',
	},
};
const actions = {
	postContact: ({ commit, rootState }, payload) => {
		const str = qs.stringify(payload);
		return new Promise((resolve, reject) => {
			axios.post(`${config.api}/politician/${rootState.userId}/contact?api_key=${rootState.apiKey}`, str)
				.then((response) => {
					resolve(response);
					commit('setSuccess');
				})
				.catch((error) => {
					reject(error);
					commit('setError', error.response.data, { root: true });
					commit('statusCheck', error.response.status);
				});
		});
	},
	getContact: ({ commit, rootState }) => {
		axios.get(`${config.api}/politician/${rootState.userId}/ticket/types/?api_key=${rootState.apiKey}`)
			.then((response) => {
				commit('setContact', response.data, { root: true });
			}).catch((error) => {
				commit('statusCheck', error.response.status);
			});
	},
	postTicketConfig: ({ commit, rootState }, payload) => {
		const str = qs.stringify(payload);
		return new Promise((resolve, reject) => {
			axios.put(`${config.api}/politician/${rootState.userId}/ticket/types/${
				payload.ticket_type_id}?api_key=${rootState.apiKey}`, str)
				.then((response) => {
					resolve(response);
					commit('setSuccess');
				})
				.catch((error) => {
					reject(error);
					commit('setError', error.response.data, { root: true });
					commit('statusCheck', error.response.status);
				});
		});
	},
	getTicketTypes: ({ commit }, payload) => {
		axios.get(`${config.api}/politician/${payload.userId}/ticket/types?api_key=${payload.apiKey}`)
			.then((response) => {
				commit('setTicketTypes', response.data);
			}).catch((error) => {
				commit('statusCheck', error.response.status);
			});
	},
	getGreeting: ({ commit }, payload) => {
		axios.get(`${config.api}/politician/${payload.userId}/greeting?api_key=${payload.apiKey}`)
			.then((response) => {
				commit('setGreeting', response.data, { root: true });
			}).catch((error) => {
				commit('statusCheck', error.response.status);
			});
	},
	setGreeting: ({ commit, rootState }, payload) => {
		const str = qs.stringify(payload);
		return new Promise((resolve, reject) => {
			axios.post(`${config.api}/politician/${rootState.userId}/greeting?api_key=${rootState.apiKey}`, str)
				.then((response) => {
					resolve(response);
					commit('setSuccess');
				})
				.catch((error) => {
					reject(error);
					commit('setError', error.response.data, { root: true });
					commit('statusCheck', error.response.status);
				});
		});
	},
	getDialog: ({ commit }, payload) => {
		return new Promise((resolve, reject) => {
			axios
				.get(`${config.api}/dialog?api_key=${payload.apiKey}`)
				.then((response) => {
					response.data.dialogs.questions = response.data.dialogs.map((dialog) => {
						const ret = dialog.questions.sort((a, b) => {
							return a.id - b.id;
						});
						return ret;
					});
					resolve(response);
					commit('setDialog', response.data);
				})
				.catch((error) => {
					reject(error);
					commit('setError', error);
					commit('statusCheck', error.response.status);
				});
		});
	},
};

const mutations = {
	// eslint-disable-next-line no-shadow
	setContact(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.contact = payload;
	},
	statusCheck: (state, payload) => {
		if (payload === 403) {
			sessionStorage.setItem('statusCode', payload);
		}
	},
	setTicketTypes(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.ticketTypes = payload;
	},
	setGreeting(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.greeting = payload;
	},
	setDialog: (state, payload) => {
		state.dialog = payload;
	},
};


export default {
	state,
	actions,
	mutations,
};



// WEBPACK FOOTER //
// ./_source/javascripts/modules/profile/store.js